import { Component, inject } from '@angular/core';
import { LocalCorridorService } from '../proxy/planning/controllers';
import { ListService } from '@abp/ng.core';
import {
  CardComponent,
  CardBodyComponent,
  ConfirmationService,
} from '@abp/ng.theme.shared';
import {
  LocalCorridorCreateDto,
  LocalCorridorDto,
  LocalCorridorExcelDownloadDto,
  LocalCorridorUpdateDto,
} from '../proxy/planning/dtos/local-corridor';
import { LOCALCORRIDOR_CONFIG, LOCALCORRIDOR_FIELDS } from './local-corridor.config';
import { BaseHierarchicalCrudComponent, CrudPage, GenericForm } from '@zendra/shared';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-local-corridor',
  imports: [
    CommonModule,
    CardComponent,
    CardBodyComponent,
    CrudPage,
    GenericForm,
  ],
  providers: [ListService, LocalCorridorService, ConfirmationService],
  templateUrl: './local-corridor.html',
  styleUrl: './local-corridor.scss',
})
export class LocalCorridor extends BaseHierarchicalCrudComponent<
  LocalCorridorDto,
  LocalCorridorCreateDto,
  LocalCorridorUpdateDto,
  LocalCorridorExcelDownloadDto
> {
  service = inject(LocalCorridorService);
  config = LOCALCORRIDOR_CONFIG;
  fields = LOCALCORRIDOR_FIELDS;

  protected prepareUpdateDto(data: any, selected: LocalCorridorDto): LocalCorridorUpdateDto {
    return {
      name: data.name,
      code: data.code,
      departmentId: data.departmentId,
      locationId: data.locationId,
      zoneId: data.zoneId,
      concurrencyStamp: selected.concurrencyStamp,
    };
  }

  protected getEntityName(): string {
    return 'LocalCorridor';
  }
}
